import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  getLayerId,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_COLOR } from '@pn/services/styles';
import { setOriginalLayers } from '.';

export const dispositions_historical: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'dispositions_historical',
  dataType: 'dispositions_historical',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Historical Dispositions',
  description: '155k dispositions in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: {
    layers: [
      {
        id: getLayerId('dispositions_historical', 'dispositions_historical', 0),
        name: 'Historical Dispositions',
        type: LayerType.Polygon,
        style: {
          color: 'hsla(45, 75%, 40%, 0.25)',
        },
        source: {
          type: 'vector',
          minzoom: 6,
          maxzoom: 10,
          tiles: [
            isProduction()
              ? 'https://tiles.stackdx.com/dispositions_historical/{z}/{x}/{y}.pbf'
              : 'https://staging-tiles.stackdx.com/dispositions_historical/{z}/{x}/{y}.pbf',
          ],
        },
        sourceLayer: 'dispositions_historical',
        renderAsPoints: true,
      },
      {
        id: getLayerId('dispositions_historical', 'dispositions_historical', 1),
        name: 'Border 1',
        type: LayerType.Line,
        style: {
          color: DEFAULT_COLOR,
          width: 0.5,
        },
        source: {
          type: 'vector',
          minzoom: 6,
          maxzoom: 10,
          tiles: [
            isProduction()
              ? 'https://tiles.stackdx.com/dispositions_historical/{z}/{x}/{y}.pbf'
              : 'https://staging-tiles.stackdx.com/dispositions_historical/{z}/{x}/{y}.pbf',
          ],
        },
        sourceLayer: 'dispositions_historical',
        renderAsPoints: true,
      },
    ],
  },
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/dispositions_historical',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'disposition_number',
      'status',
      'company',
      'disposition_type_name',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'dispositions_historical',
    dataType: 'dispositions_historical',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
